import ContactViewComponent from './ContactView.component';

export default ContactViewComponent;
